import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import {
  AcademicYearDTO,
  CourseDeliveryDTO,
  CourseSetDTO,
  CustomerDTO,
  SiteDTO,
} from "@beable/roster-backend-client-v1";
import CourseDashboard from "../../Schedule/Course/CourseDashboard";

interface CourseDashboardDialogProps {
  open: boolean;
  customer: CustomerDTO;
  site: SiteDTO;
  academicYear: AcademicYearDTO;
  course?: CourseDeliveryDTO | undefined;
  courseSet?: CourseSetDTO | undefined;
  handleClose: () => void;
}

export default function CourseDashboardDialog({
  open,
  customer,
  site,
  academicYear,
  course,
  courseSet,
  handleClose,
}: CourseDashboardDialogProps) {
  return (
    <Dialog
      aria-labelledby="course-dashboard-modal-title"
      aria-describedby="course-dashboard-description"
      open={open}
      scroll="body"
      onClose={handleClose}
      fullWidth
      maxWidth="lg"
    >
      <DialogContent>
        <Typography variant="h5">Showing data for Academic Year {academicYear?.schoolYear}</Typography>
        <CourseDashboard
          customer={customer}
          site={site}
          academicYearId={academicYear?.academicYearId}
          course={course}
          courseSet={courseSet}
          autoRefresh={true}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
